import React from 'react'
import { Skeleton } from 'antd'

import layout from './ProjectHealthDashboard.module.css'
import sk from './ReportSkeleton.module.css'

const METRIC_PLACEHOLDER_COUNT = 4

const HealthMetricCardsSkeleton = () => (
    <div className={`${layout.metricsGrid} ${sk.skeletonBlock}`} aria-hidden>
        {Array.from({ length: METRIC_PLACEHOLDER_COUNT }).map((_, index) => (
            <div key={index} className={layout.metricCard}>
                <Skeleton.Avatar
                    active
                    shape="square"
                    className={sk.metricIconSk}
                />
                <div className={layout.metricBody}>
                    <Skeleton.Input active className={sk.metricLabelSk} />
                    <Skeleton.Input active className={sk.metricValueSk} />
                </div>
            </div>
        ))}
        <div className={layout.utilizationCard}>
            <div className={layout.utilizationHeader}>
                <Skeleton.Input active className={sk.utilLabelSk} />
                <Skeleton.Input active className={sk.utilValueSk} />
            </div>
            <Skeleton.Input active className={sk.utilTrackSk} />
        </div>
    </div>
)

export default HealthMetricCardsSkeleton
